import { render, staticRenderFns } from "./CopilotSidebar.vue?vue&type=template&id=e426e27e&scoped=true"
import script from "./CopilotSidebar.vue?vue&type=script&lang=js"
export * from "./CopilotSidebar.vue?vue&type=script&lang=js"
import style0 from "./CopilotSidebar.vue?vue&type=style&index=0&id=e426e27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e426e27e",
  null
  
)

export default component.exports